
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { X } from 'lucide-react';
import { EcommercePriceFilters } from '@/types/database/ecommerce-prices';

interface EcommercePricesFilterProps {
  filters: EcommercePriceFilters;
  onFiltersChange: (filters: EcommercePriceFilters) => void;
}

const EcommercePricesFilter: React.FC<EcommercePricesFilterProps> = ({
  filters,
  onFiltersChange,
}) => {
  const updateFilter = (key: keyof EcommercePriceFilters, value: string) => {
    onFiltersChange({
      ...filters,
      [key]: value || undefined,
    });
  };

  const clearFilters = () => {
    onFiltersChange({});
  };

  const hasActiveFilters = Object.values(filters).some(value => value && value.length > 0);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">Filter Prices</h3>
        {hasActiveFilters && (
          <Button variant="outline" size="sm" onClick={clearFilters}>
            <X className="h-4 w-4 mr-2" />
            Clear Filters
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="search">Search</Label>
          <Input
            id="search"
            placeholder="Search products..."
            value={filters.search || ''}
            onChange={(e) => updateFilter('search', e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="location">Location</Label>
          <Input
            id="location"
            placeholder="Filter by location"
            value={filters.location || ''}
            onChange={(e) => updateFilter('location', e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="product_name">Product Name</Label>
          <Input
            id="product_name"
            placeholder="Filter by product"
            value={filters.product_name || ''}
            onChange={(e) => updateFilter('product_name', e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="date_from">Date From</Label>
          <Input
            id="date_from"
            type="date"
            value={filters.date_from || ''}
            onChange={(e) => updateFilter('date_from', e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="date_to">Date To</Label>
          <Input
            id="date_to"
            type="date"
            value={filters.date_to || ''}
            onChange={(e) => updateFilter('date_to', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default EcommercePricesFilter;
